import { InjectionToken } from '@angular/core';
import { APP_CONSTANTS } from 'app/app.config';

export interface AuthConfig {
  REMOTE: {
    UPDATE_TOKEN_LANGUAGE: string;
    UPDATE_ACTIVATION_TOKEN: string;
  };
}

const baseURL = APP_CONSTANTS.API_URL;

export const AUTH_CONSTANTS: AuthConfig = {
  REMOTE: {
    UPDATE_TOKEN_LANGUAGE: `${baseURL}update-token/language`,
    UPDATE_ACTIVATION_TOKEN: `${baseURL}activation-token`
  }
};

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('auth.config');
